var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"room-browser-discover"}},[_c('Category',{ref:"category",attrs:{"standalone":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }